<template>
    <list
        :title="$t(`pages.${ $options.module }.list.title`)"
        :count="list.length"
        :lang="lang"
        @new="newItem"
        @language="changeLang"
    >
        <template v-slot:default>
            <list-item
                v-for="item in list"
                :key="item.id"
                :config="$options.listItemConfig"
                :state="item.state"
                @activate="activateItem(item)"
                @deactivate="deactivateItem(item)"
                @edit="editItem(item.id)"
                @delete="removeItem(item.id)"
            >
                {{ getItemTitle(item) }}
            </list-item>
        </template>
        <template v-slot:extras>
            <pop-down
                v-if="pop.active"
                :class="pop.className"
                @close="popClose"
            >
                {{ pop.message }}
            </pop-down>
            <modal
                v-if="remove.open"
                :title="$t(`pages.${ $options.module }.list.remove_title`)"
                :message="$t(`pages.${ $options.module }.list.remove_message`)"
                :cancelShow="true"
                :confirmLabel="$t(`pages.${ $options.module }.list.remove_confirm_label`)"
                @cancel="removeCancel"
                @confirm="removeConfirm"
            />
        </template>
    </list>
</template>

<script>
import ListMixin from '@/components/list/ListMixin';
import PopDownMixin from '@/components/PopDownMixin';

export default {
    mixins: [ListMixin, PopDownMixin],
    name: 'PppElementsList',
    module: 'pppelements',
    listItemConfig: {
        menu: true,
        changeState: true,
        edit: true,
        delete: true,
    },
    methods: {
        compareTitles(firstEl, secondEl) {
            const firstTitle = (typeof firstEl.locales[this.lang] !== 'undefined' && typeof firstEl.locales[this.lang].title !== 'undefined')
                ? firstEl.locales[this.lang].title.toUpperCase()
                : '(empty)';
            const secondTitle = (typeof secondEl.locales[this.lang] !== 'undefined' && typeof secondEl.locales[this.lang].title !== 'undefined')
                ? secondEl.locales[this.lang].title.toUpperCase()
                : '(empty)';

            if (firstTitle < secondTitle) {
                return -1;
            }
            if (firstTitle > secondTitle) {
                return 1;
            }

            return 0;
        },
    },
};
</script>
